/* eslint-disable react/no-array-index-key */
import React from 'react';

import { BoundingBox } from '@vlabs/uikit/components/bounding-box/BoundingBox';
import type { WithDataTestid } from '@vlabs/uikit/types';

import { DetectionPoint } from './DetectionPoint';
import { buildTestid } from '../../../lib/utils';
import type { Detection } from '../types';

export interface DetectionOverlayProps extends WithDataTestid {
  detections: Detection;
}

const displayName = 'DetectionOverlay';
const testid = buildTestid(displayName);

function DetectionOverlay({
  detections,
  'data-testid': dataTestId,
}: DetectionOverlayProps): React.JSX.Element | null {
  if (detections.type === 'bbox') {
    return (
      <React.Fragment>
        {detections.coordinates.map((rectangle, index) => (
          <BoundingBox
            // FIXME: Добавить в типы поддержку черного цвета
            color={detections.color}
            key={index}
            // FIXME: В ките надо подправить типы у BoundingBox, бэк отдает просто 4 числа в массиве или объект, как в типе
            rectangle={rectangle}
            {...testid(dataTestId, index.toString())}
          />
        ))}
      </React.Fragment>
    );
  }

  if (detections.type === 'point') {
    return (
      <React.Fragment>
        {detections.coordinates.map((point, index) => (
          <DetectionPoint
            color={detections.color}
            coordinates={point}
            key={index}
            size={detections.dotSize}
            {...testid(dataTestId, index.toString())}
          />
        ))}
      </React.Fragment>
    );
  }

  return null;
}

DetectionOverlay.displayName = displayName;

export { DetectionOverlay };
